import { HttpErrorResponse } from '@angular/common/http';

/**
 * Extrae un mensaje legible (español, apto para toast) del error real que devuelve
 * la API, en vez de mostrar un mensaje hardcodeado y potencialmente engañoso.
 *
 * Soporta el shape estándar del backend `{ status, message, details }` y respuestas
 * de texto plano. La traza técnica (código HTTP) solo se registra en consola.
 */
export function extractApiErrorMessage(error: unknown, fallback: string): string {
  if (error instanceof HttpErrorResponse) {
    if (error.status) {
      console.warn(`[marketing-forms] Error HTTP ${error.status} ${error.statusText || ''}`.trim(), error.error);
    }

    const body = error.error;

    if (typeof body === 'string' && body.trim()) {
      return body.trim();
    }

    if (body && typeof body === 'object') {
      const record = body as Record<string, unknown>;
      for (const key of ['message', 'error', 'detail', 'title']) {
        const value = record[key];
        if (typeof value === 'string' && value.trim()) {
          return value.trim();
        }
      }
    }

    return fallback;
  }

  if (typeof error === 'string' && error.trim()) {
    return error.trim();
  }

  if (error && typeof error === 'object') {
    const value = (error as Record<string, unknown>)['message'];
    if (typeof value === 'string' && value.trim()) {
      return value.trim();
    }
  }

  return fallback;
}
